export type ReceiptStatus = 'processing' | 'completed' | 'failed' | 'manual_review';

export interface ReceiptItem {
  description: string;
  quantity?: number;
  unitPrice?: number;
  total: number;
}

export interface ExtractedReceiptData {
  merchant?: string;
  date?: string;
  total?: number;
  currency?: string;
  items?: ReceiptItem[];
  taxAmount?: number;
  subtotal?: number;
  paymentMethod?: string;
  category?: string;
}

export interface Receipt {
  id: string;
  userId: string;
  imageUrl: string;
  imageKey: string;
  thumbnailUrl?: string | null;
  status: ReceiptStatus;
  extractedData?: ExtractedReceiptData | null;
  merchantName?: string | null;
  merchantTaxId?: string | null;
  totalAmount?: string | null;
  currency?: string | null;
  receiptDate?: string | null;
  receiptNumber?: string | null;
  items?: ReceiptItem[] | null;
  taxDeductible?: boolean | null;
  taxCategory?: string | null;
  taxYear?: number | null;
  ocrConfidence?: string | null;
  processingTimeMs?: number | null;
  createdAt: string;
  updatedAt: string;
}

export interface ReceiptWithTransactions extends Receipt {
  transactions: Array<{
    id: string;
    type: string;
    amount: string;
    currency: string;
    description: string | null;
    merchantName: string | null;
    createdAt: string;
  }>;
}

export interface ReceiptListResponse {
  receipts: Receipt[];
  total: number;
  limit: number;
  offset: number;
}

export interface ReceiptFilters {
  limit?: number;
  offset?: number;
  year?: number;
  status?: ReceiptStatus;
}

export interface ReceiptStats {
  total: number;
  pending: number;
  processing: number;
  completed: number;
  failed: number;
  successRate: number;
}

export const RECEIPT_STATUS_LABELS: Record<ReceiptStatus, string> = {
  processing: 'Processando',
  completed: 'Concluido',
  failed: 'Falhou',
  manual_review: 'Revisao Manual',
};

export const RECEIPT_STATUS_COLORS: Record<ReceiptStatus, string> = {
  processing: '#f59e0b',
  completed: '#10b981',
  failed: '#ef4444',
  manual_review: '#8b5cf6',
};
